/*=========================================================================================
  File Name: moduleStockState.js
  Description: Supplier Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  suppliers: [],
};
